import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeStep } from "../store/settings/settingsSlice";
import { updateRegistrant } from "../store/registrant/registrantSlice";
import HadAssistanceForm from "../Forms/HadAssistanceForm";
import BackButton from "../Components/BackButton";
import { generateRegistrationID, createFormPayload, createImagePayload, sendSurveyData, getPublicKey } from '../services/api/voter';
import Bugsnag from '@bugsnag/js';
import { getContent } from "../content";

function HadAssistance() {
    const partner = useSelector((state) => state.partner);
    const registrant = useSelector((state) => state.registrant);
    const tracking = useSelector((state) => state.tracking);
    const currentLanguage = useSelector((state) => state.settings.currentLanguage);

    let navigate = useNavigate();
    const dispatch = useDispatch();

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    React.useEffect(() => {
        dispatch(changeStep([5, 6]));
    }, []);

    const onSubmit = async (data) => {
        dispatch(updateRegistrant({
            had_assistance: data.had_assistance
        }));

        let formPayload = {
            ...registrant,
            had_assistance: data.had_assistance
        };

        if (data.had_assistance == 'yes') {
            navigate('/assistance-information');
        } else {
            setIsSubmitting(true);

            try {
                const responseID = generateRegistrationID();
                const pubKey = await getPublicKey();

                const encryptedResult = createFormPayload(formPayload, tracking, "registration_online", currentLanguage, pubKey.public_key);
                const encryptedSignature = createImagePayload(formPayload.signature_data, 'sig', pubKey.public_key);
                const encryptedSignatureHD = createImagePayload(formPayload.signature_data_hd, 'sig_hd', pubKey.public_key);

                let formRequest = sendSurveyData(responseID, null, "form", encryptedResult.key, encryptedResult.payload).then(() => {
                    return true;
                }).catch((error) => {
                    return false;
                });

                let signatureRequest = sendSurveyData(responseID, null, "sig", encryptedSignature.key, encryptedSignature.payload).then(() => {
                    return true;
                }).catch((error) => {
                    return false;
                });

                let signatureHDRequest = sendSurveyData(responseID, null, "sig_hd", encryptedSignatureHD.key, encryptedSignatureHD.payload).then(() => {
                    return true;
                }).catch((error) => {
                    return false;
                });

                const result = await Promise.all([formRequest, signatureRequest, signatureHDRequest]);
                setIsSubmitting(false);

                if (result.includes(false)) {
                    alert('An error occurred while saving your registration. Please try again.');
                } else {
                    navigate('/confirmation');
                }
            } catch (e) {
                Bugsnag.notify(e);
                alert("An error occurred while submitting the form.  Please try again.");

                setIsSubmitting(false);
            }
        }
    };

    return (
        <section className="flex flex-col gap-4">
            <div className="">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="my-4 md:mt-8 lg:mt-16">{getContent('had_assistance.heading')}</h2>
                <p>{getContent('had_assistance.content')}</p>
            </div>
            <div className="">
                <div className="p-8 border-4 rounded-lg border-evcpa-darkpurple">
                    <HadAssistanceForm submit={onSubmit} disabled={isSubmitting} />
                </div>
            </div>
        </section>
    );
}

export default HadAssistance;